import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.css';
import { getCustomerSupportNumber, getManualName, getWAPBusinessUnit } from '../../containers/Utils';

let supportNumber = '';

function getSupportNumber(props) {
  if (supportNumber === '') {
    supportNumber = getCustomerSupportNumber(props);
  }
  return supportNumber;
}

const Footer = props => (
  <Grid verticalAlign="middle" textAlign="center" styleName="container">
    <Grid.Row>
      <Grid.Column floated="left" textAlign="left" width={3}>
        Copyright &copy; {new Date().getFullYear()}, AARP.org
      </Grid.Column>
      <Grid.Column textAlign="right" width={2}>
        <p styleName="BUColor">Business Unit: {getWAPBusinessUnit(props)}</p>
      </Grid.Column>
      <div>
        {
          (getSupportNumber(props) !== '' && getSupportNumber(props) !== undefined) ?
            <Grid.Column textAlign="right" width={2}>
              Customer Support: {getSupportNumber(props)}
            </Grid.Column>
            : null
        }
      </div>
      <Grid.Column textAlign="right" width={2}>
        <a
          styleName="link"
          target="_blank"
          rel="noopener noreferrer"
          href={getManualName(props)}
        >User Manual
        </a>
      </Grid.Column>
      <Grid.Column textAlign="right" width={2}>
        <a
          styleName="link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.aarp.org/about-aarp/privacy-policy"
        >Privacy Policy
        </a>
      </Grid.Column>
      <Grid.Column textAlign="right" width={3}>
        <a
          styleName="link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.aarp.org/about-aarp/terms-of-service"
        >Terms of Service
        </a>
      </Grid.Column>
    </Grid.Row>
  </Grid >
);

export default Footer;



// WEBPACK FOOTER //
// ./src/app/components/Footer/index.js